import React from 'react';

export interface ButtonContainerProps {
	children: React.ReactNode
	flex?: boolean
	wrap?: boolean
	center?: boolean
	column?: boolean
	m_modal?: boolean
	m_small?: boolean
	m_medium?: boolean
}

const ButtonContainer = (props: ButtonContainerProps) => {
	const classNames = Object.keys(props).reduce((_classnames, key)=>{
		if (key === 'children' || key === 'style' ){
			return _classnames;
		}

		return `${_classnames} ${key}`;
	}, '');

	return (
		<div className={ `button-container ${classNames}` }>
			{ props.children }
		</div>
	);
};

export default ButtonContainer;